<template>
  <div>
    <div v-if="value.url">
      <v-img class="clicky" style="width:100%;height:auto" :src="value.thumbnail">
        <v-btn
          color="error"
          @click="clear"
          class="item-delete"
          fab
          x-small
          style="width:16px;height:16px"
        >
          <v-icon x-small>fa-times</v-icon>
        </v-btn>
        <v-overlay absolute>
          <v-icon @click="$eventBus.$emit('play_video',value.url)">fa-play</v-icon>
        </v-overlay>
      </v-img>
    </div>

    <div v-else>
      <v-progress-circular
        :indeterminate="upload_progress >=100 ? true : false"
        :value="upload_progress"
        color="green"
        v-if="uploading"
      ></v-progress-circular>
      <v-btn fab dark color="blue" v-else @click="openFileSelect">
        <v-icon>fa-upload</v-icon>
      </v-btn>
    </div>

    <input
      type="file"
      style="display:none"
      :id="`file-${random_id}`"
      @change="handleFileChange($event)"
      accept="video/mp4, video/quicktime"
    />
    
  </div>
</template>
<script>
export default {
  name: "AdminVideoUploader",
  props: ["value"],
  data: () => ({
    upload_progress: 0,
    uploading: false,
    random_id: Math.round(Math.random() * 100000)
  }),
  computed: {
    show_clear() {
      if (this.value) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    clear(ev) {
      ev.preventDefault();
      //ping server with url and tell it to delete from s3.
      if (!confirm("Confirm delete ?")) {
        return;
      }
      this.$emit("input", { url: "", thumbnail: "" });
      this.$emit("change", this.value);
    },
    openFileSelect() {
      document.querySelector(`#file-${this.random_id}`).click();
    },
    async uploadFile(file) {
      this.uploading = true;
      try {
        this.upload_progress = 0;
        var upload_options = {
          headers: {
            "Content-Type": file.type
          },
          Metadata: {
            "Content-Disposition": "attachment"
          },
          onUploadProgress: function(progressEvent) {
            console.log(progressEvent);
            this.upload_progress = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this)
        };
        let form = new FormData();
        form.append("file", file);
        let uploaded = await this.$api.put(
          `/admin/upload`,
          form,
          upload_options
        );
        this.$emit("input", uploaded);
        this.$emit("change", this.value);
      } catch (ex) {
        alert("Upload failed");
      }
      this.uploading = false;
    },
    handleFileChange: function(ev) {
      this.$emit("input", null);
      //validate then upload.
      ev.preventDefault();
      let file;
      if (ev.target.files) {
        file = ev.target.files[0];
      }
      if (file) {
        this.uploadFile(file);
        document.querySelector(`#file-${this.random_id}`).value = null;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.addbox {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
}
.item-delete {
  position: absolute;
  top: 3px;
  right: 3px;
  z-index: 201;
}
</style>
